import { getPagePath } from "./../helpers/system";

export const APIVERSION = `2`;
export const GCP_API_BASE_URL = process.env.REACT_APP_API_ENDPOINT;
export const SERVERPATH = `${GCP_API_BASE_URL}${APIVERSION}`;

export function objToFormData(data) {
    const form = new FormData();

    for (let name in data) {
        if (data[name] && (data[name].constructor === File || data[name].constructor === Blob)) {
            form.append(name, data[name], data[name].name);
        } else {
            form.append(name, data[name]);
        }
    }

    return form;
}

export function handleApiError(error) {
    const {
        data: { status, data },
    } = error.response || {};

    let redirect = false;
    let notify = false;
    switch (status) {
        case 404: {
            redirect = getPagePath("NotFound");
            break;
        }
        case "FAILED":
        default: {
            const { message = false } = data || {};
            notify = { title: "Error", message: message || "Something went wrong!" };
        }
    }

    return { redirect, notify };
}
